<template v-slot="color">
    <div id="post-small-block-horizontal" class="post-block-style clearfix col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div class="row">
            <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                <div class="post-thumb">
                    <a :href="data.post_url">
                        <img class="img-fluid" :src="data.photo" :alt="data.title">
                    </a>
                </div>
                <a class="post-cat" :style="{ 'background-color': this.color }" :href="data.keywords_search_url" v-if="data.first_keyword">{{ data.first_keyword }}</a>
            </div>
            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 pt-3 pt-lg-0">
                <div class="post-content">
                    <h2 class="post-title">
                        <a :href="data.post_url" v-html="data.title"></a>
                    </h2>
                    <div class="post-meta">
                        <span class="post-author"><a :href="data.list_url">{{ data.menu_name }}</a></span>
                        <span class="post-date">{{ data.creation_date | formatShortDate }}</span>
                    </div>
                    <p>{{ data.short_content }}</p>
                </div><!-- Post content end -->
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'PostSmallBlockHorizontal',
        props: ['title', 'color', 'data'],
    }
</script>

<style lang="scss">

    @import '~@/absctracts/variables.scss';
    @import '~@/absctracts/mixins.scss';

    #post-small-block-horizontal {
        position: relative;
        overflow: hidden;

        @media (max-width: 576px) {
            padding-right: 0px;
        }

        .post-thumb {
            max-width: 100%;
            position: relative;
            overflow: hidden;

            img {
                display: block;
                object-fit: cover;
                width: 100%;
                -webkit-transition: all .3s ease-out;
                -o-transition: all .3s ease-out;
                transition: all .3s ease-out;
                max-width: 100%;
                height: 180px;
            }

            img:hover {
                @include imgHoverScale(1.15);
            }
        }

        .post-cat {
            background: $dark-grey;
            color: #fff;
            display: inline-block;
            font-size: 10px;
            font-weight: 700;
            height: 20px;
            margin-left: 20px;
            line-height: 20px;
            padding: 0 5px;
            position: absolute;
            text-transform: uppercase;
            top: 20px;
            z-index: 1;
        }

        .post-cat:before {
            border-top: 8px solid $dark-grey;
            content: '';
            position: absolute;
            left: 0;
            z-index: 0;
            bottom: -8px;
            border-right: 8px solid transparent;
        }

        .post-content {
            padding: 0px;
            position: relative;
            z-index: 1;

            .post-title {
                font-size: 20px;
                line-height: 24px;
                margin: 0px 0 0;

                a {
                    color: $dark-grey;
                }

                a:hover {
                    color: $red;
                }
            }

            .post-meta {
                margin: 3px 0;

                span {
                    font-size: 12px;
                    color: #a3a3a3;
                    margin-right: 8px;
                    padding-right: 10px;
                    border-right: 1px solid #dedede;
                    line-height: 12px;
                    display: inline-block;
                }

                .post-author a {
                    color: $dark-grey;
                    font-weight: 700;
                }

                .post-date {
                    border-right: 0;
                }
            }

            p {
                font-size: 13px;
            }
        }
    }
</style>